/* 监控数据格式转换工具*/
import moment from 'moment';
export function queryTog2(data = {}, t) {
  if (data.result && data.result.length && data.result[0].value) {
    if (t) {
      return t(data.result[0].value[1]);
    }

    return data.result[0].value[1];
  }
  return 0;
}

export function queryRangeTog2(data = {}) {
  let res = [];
  if (data.result && data.result.length && data.result[0].value) {
    const arr = data.result[0].value;
    res = arr.map(item => {
      return {
        x: moment(new Date(arr[0] * 1000))
          .locale('zh-cn')
          .format('HH:mm:ss'),
        y: Number(arr[1]),
        y1: Number(arr[1]),
        y2: Number(arr[1])
      };
    });
  }

  return res;
}

export function queryRangeTog2F(data = {}, round) {
  let res = [];
  if (data.result && data.result.length && data.result[0].value) {
    if (round) {
      res = data.result[0].value.map(value => ({
        x: Number(value[0] * 1000),
        y: Math.round(Number(value[1]))
      }));
    } else {
      res = data.result[0].value.map(value => ({
        x: Number(value[0] * 1000),
        y: Math.round(Number(value[1]))
      }));
    }
  }
  return res;
}



// WEBPACK FOOTER //
// ./src/utils/monitorDataUtil.js